import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight, FiLinkedin } from 'react-icons/fi';
import { PERSONAL_INFO, SITE_METADATA } from '../utils/constants';
import profilePhoto from '../assets/images/anu-singh.jpeg';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.16, delayChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 18 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.55, ease: 'easeOut' }
    }
  };

  return (
    <section className="min-h-[calc(100vh-5rem)] flex items-center hero-gradient relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-48 -left-40 w-96 h-96 bg-navy/5 rounded-full blur-3xl" />
      </div>

      <motion.div
        className="container-custom px-6 py-20 md:py-28 relative z-10"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="grid grid-cols-1 lg:grid-cols-[1.3fr_0.7fr] gap-12 lg:gap-16 items-center max-w-6xl mx-auto">
          <div>
            <motion.p variants={itemVariants} className="text-sm md:text-base uppercase tracking-[0.22em] text-gold font-semibold mb-5">
              {PERSONAL_INFO.title}
            </motion.p>

            <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl font-serif text-navy mb-6">
              {PERSONAL_INFO.name}
            </motion.h1>

            <motion.h2 variants={itemVariants} className="text-2xl md:text-4xl font-serif text-navy leading-tight mb-6 max-w-3xl">
              Building AI sales infrastructure for the next generation of real estate.
            </motion.h2>

            <motion.p variants={itemVariants} className="text-lg md:text-xl text-charcoal leading-relaxed max-w-3xl mb-9">
              I work at the intersection of AI, PropTech and real estate sales, focused on how intelligent systems can connect buyer engagement, decision support and human sales execution across the property journey.
            </motion.p>

            <motion.div variants={itemVariants} className="mb-9">
              <p className="text-xs uppercase tracking-[0.22em] text-navy/50 font-semibold mb-3">
                Published in
              </p>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm md:text-base font-medium text-navy">
                <a
                  href="https://www.housingwire.com/articles/the-first-15-minutes-that-cost-brokerages-revenue/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold hover:underline underline-offset-4 transition-colors"
                >
                  HousingWire
                </a>

                <span className="text-gold" aria-hidden="true">|</span>

                <a
                  href="https://mena.entrepreneur.com/business-news/why-speed-not-persuasion-is-the-real-problem-in-real-estate-sales"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold hover:underline underline-offset-4 transition-colors"
                >
                  Entrepreneur Middle East
                </a>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4">
              <a href="#perspectives" className="btn-primary inline-flex items-center justify-center gap-2">
                Explore My Work <FiArrowRight />
              </a>
              <a
                href={SITE_METADATA.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary inline-flex items-center justify-center gap-2"
              >
                <FiLinkedin /> Connect on LinkedIn
              </a>
            </motion.div>
          </div>

          <motion.div variants={itemVariants} className="flex justify-center lg:justify-end">
            <div className="rounded-3xl border border-gold/60 p-2 bg-white/70 shadow-sm">
              <img
                src={profilePhoto}
                alt="Anu Singh, Co-Founder and CEO of Zakool AI"
                className="w-72 h-96 md:w-96 md:h-[30rem] rounded-2xl object-cover object-center"
              />
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;